import { render } from "./HazLicenseS2List.vue?vue&type=template&id=78d13ef2"
import script from "./HazLicenseS2List.vue?vue&type=script&lang=js"
export * from "./HazLicenseS2List.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__